export const Spinner = ({ size = 'w-10 h-10', color = 'text-gray-500' }) => {
  return (
    <div className={`lds-spinner ${size} ${color}`}>
      {[...Array(12)].map((_, i) => (
        <div key={i}></div>
      ))}
    </div>
  );
};
